module.exports = __webpack_public_path__ + "img/Bonaire.109d6a75.svg";